import { extend } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import TagsPage from 'ext:flarum/tags/forum/components/TagsPage';
export default function extendTagOverview() {
  extend(TagsPage.prototype, 'view', function (markup) {
    // Pending xhr to load all tags, throw back loading indicator.
    if (this.loading) {
      return markup;
    }
    if (app.forum.attribute('blogHideTags') == false) return markup;

    // Get blog tag ID's
    const blogTags = app.forum.attribute('blogTags') || [];
    const tag_tiles_parent = findChild(markup, 'TagsPage-content', true);
    const tag_tiles = tag_tiles_parent == null ? void 0 : tag_tiles_parent.children[0];
    if (!tag_tiles_parent || !tag_tiles) return markup;

    // Map through the tiles and remove tiles that are part of the blog
    tag_tiles.children = tag_tiles.children.map((tile, i) => {
      return blogTags.indexOf(this.tags[i].id()) >= 0 ? null : tile;
    });
    return markup;
  });
  extend(IndexSidebar.prototype, 'navItems', function (items) {
    if (app.forum.attribute('blogHideTags') == false) return items;
    const blogTags = app.forum.attribute('blogTags') || [];
    blogTags.forEach(id => {
      items.remove("tag".concat(id));
    });
    return items;
  });
}
function findChild(parent, childClass, recursive, maxDepth, depth) {
  if (recursive === void 0) {
    recursive = false;
  }
  if (maxDepth === void 0) {
    maxDepth = 50;
  }
  if (depth === void 0) {
    depth = 0;
  }
  const children = getChildren(parent);
  let child = null;
  for (let i = 0; i < children.length; i++) {
    var _children$i;
    const childClassName = ((_children$i = children[i]) == null || (_children$i = _children$i.attrs) == null ? void 0 : _children$i.className) || '';
    if (childClassName.includes(childClass)) {
      child = children[i];
      break;
    }
  }

  // Recursive search
  if (recursive && !child && depth < maxDepth) {
    for (let subParent of children) {
      const subChild = findChild(subParent, childClass, true, maxDepth, depth + 1);
      if (subChild) {
        return subChild;
      }
    }
  }
  return child;
}
function getChildren(parent) {
  if (Array.isArray(parent)) {
    return parent;
  }
  const children = (parent == null ? void 0 : parent.children) || [];
  if (!Array.isArray(children)) {
    return [];
  }
  return children;
}
flarum.reg.add('v17development-blog', 'forum/utils/extendTagOverview', extendTagOverview);